import { SET_SELECTION_PROPS_MUT } from "./constants.js";

export default {
  [SET_SELECTION_PROPS_MUT](state, newState) {
    Object.assign(state, newState);
  }
};
